export default {
  CREATION_INITIATED: 'Proposal Creation Initiated',
  SIDEBAR_CLICKED: 'Proposals Sidebar Clicked',
  CREATE_PROPOSAL_FROM_PROPOSALS: 'Create Proposal from Proposals',
  GENERATED: 'Proposal Generated',
  SAVED: 'Proposal Saved',
  SEND_PROPOSAL_TO_CLIENT_MODAL_LAUNCHED: 'Send Proposal to Client Modal Launched', // used
  LINK_COPIED: 'Proposal Link Copied',
  SHARE_VIA_WHATSAPP: 'Proposal Share via Whatsapp',
  LINK_OPENED: 'Proposal Link Opened',
  SHARE_VIA_EMAIL: 'Proposal Share via Email',
  DOWNLOADED: 'Proposal Downloaded',

  // New events
  PROPOSAL_CREATION_ATTEMPTED: 'Proposal Creation Attempted',
  PROPOSAL_CREATION_COMPLETED: 'Proposal Creation Completed',
  PROPOSAL_CREATION_FAILED: 'Proposal Creation Failed',

  BANK_PRODUCTS_FILTERED: 'Bank Products Filtered',
  BANK_PRODUCTS_VIEWED: 'Bank Products Viewed',

  PROPOSAL_UPDATE_ATTEMPTED: 'Proposal Update Attempted',
  PROPOSAL_UPDATE_COMPLETED: 'Proposal Update Completed',
  PROPOSAL_UPDATE_FAILED: 'Proposal Update Failed',

  PROPOSAL_GENERATION_ATTEMPTED: 'Proposal Generation Attempted',
  PROPOSAL_GENERATION_COMPLETED: 'Proposal Generation Completed',
  PROPOSAL_GENERATION_FAILED: 'Proposal Generation Failed',

  PROPOSAL_DUPLICATION_ATTEMPTED: 'Proposal Duplication Attempted',
  PROPOSAL_DUPLICATION_COMPLETED: 'Proposal Duplication Completed',
  PROPOSAL_DUPLICATION_FAILED: 'Proposal Duplication Failed',

  PROPOSAL_REVISED: 'Proposal Revised',

  PROPOSAL_EDIT_STARTED: 'Proposal Edit Started',
  PROPOSAL_VIEWED_STARTED: 'Proposal Viewed',
};
